import React, { useCallback, useEffect, useState } from "react";

import Modal from "../modal/Modal";
import { DEMO_BLOCKED_EVENT } from "../../utils/demoMode";

/**
 * デモモード中の書き込み操作を遮断したときに表示するモーダル。
 *
 * createAuthBaseQuery のデモガード（および BE の DemoReadOnlyMiddleware）が
 * 書き込みを止めると `soremo:demo-blocked` イベントが発火し、本コンポーネント
 * がそれを購読して表示する。送信ボタン等は無効化せずに「押したら説明する」
 * 方式にすることで、機能の存在自体はデモで伝えられるようにしている。
 */
const DemoBlockedModal: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleBlocked = () => setIsOpen(true);
    window.addEventListener(DEMO_BLOCKED_EVENT, handleBlocked);
    return () => window.removeEventListener(DEMO_BLOCKED_EVENT, handleBlocked);
  }, []);

  const handleClose = useCallback(() => setIsOpen(false), []);

  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      variant="dialog"
      title="デモモードのため、書き込みはできません"
      description={
        "このサイトはデモ用のサンプルです。閲覧は自由にお楽しみいただけますが、\nコメント送信・アップロード・編集などの操作は保存されません。"
      }
      onClose={handleClose}
      primaryAction={{
        label: "閉じる",
        onClick: handleClose,
      }}
    />
  );
};

export default DemoBlockedModal;
